import { useSession } from '@cockpitai/store/session/useSession'
import axios, { AxiosError } from 'axios'
import { unstable_batchedUpdates } from 'react-dom'

export const client = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
})

client.interceptors.request.use(
  async function (config) {
    unstable_batchedUpdates(() => {
      const { auth } = useSession.getState()

      if (auth != null) {
        config.headers.Authorization = `Bearer ${auth?.token}`
      }
    })

    config.headers = config.headers ?? {}
    const fromKey = import.meta.env.VITE_X_FROM_KEY

    if (fromKey != null) {
      config.headers['x-from-key'] = fromKey
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)

client.interceptors.response.use(
  function (response) {
    return response
  },
  function (error: AxiosError) {
    if (error.response?.status === 401) {
      unstable_batchedUpdates(() => {
        useSession.setState({ auth: null, user: null })
      })
    }

    return Promise.reject(error)
  },
)
